var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer-nav'),_c('div',{class:_vm.$style.copyright},[_vm._v("© 2020 QRAR")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }